
import { Component, Vue, Prop } from 'vue-property-decorator';

export interface CardData {
  title: string;
  subtitle: string;
  icon: string;
}

@Component({
  components: {}
})
export default class QuickActions extends Vue {
  @Prop({ required: true })
  protected data!: CardData;
  @Prop({ required: false, default: false })
  protected active!: boolean;
  protected readonly bgColorActive = 'primary lighten-4';
  protected readonly iconColorActive = 'grey lighten-3';
  protected readonly bgColorInactive = 'grey lighten-3';
  protected readonly iconColorInactive = 'primary lighten-4';
}
